// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // ✅ correct import for React 18
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './styles.css'; // or './index.css' if you use that

const root = ReactDOM.createRoot(document.getElementById('root')); // ✅ correct method
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);